import MuiButton from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { color } from 'src/themes/color';
import { sizes } from 'src/themes/sizes';

const Button = styled(MuiButton)({
  color: '#FFF',
  height: sizes.field.button,
  fontSize: sizes.fontSize.button,
  boxShadow: 'none',
  borderRadius: sizes.radius.sm,
  '&.MuiButton-containedPrimary': {
    '&:hover': {
      background: color.green.dark,
    },
  },
  '&.MuiButton-containedSecondary': {
    color: '#000',
  },
});

export default Button;
